module.exports = __webpack_public_path__ + "static/media/comet.de46970d.svg";